import { Logo } from "./Logo";
import { SITE, scrollToSection } from "@/lib/site";

export const Footer = () => (
  <footer className="border-t border-white/10 bg-[#0c0e12] px-6 lg:px-12 py-12" data-testid="site-footer">
    <div className="max-w-[1400px] mx-auto flex flex-col md:flex-row md:items-center justify-between gap-8">
      <div>
        <Logo />
        <p className="mt-4 font-mono text-[11px] uppercase tracking-[0.2em] text-slate-500 max-w-xs leading-relaxed">
          {SITE.tagline} Serving {SITE.area}.
        </p>
      </div>
      <div className="flex flex-col gap-2 font-mono text-xs uppercase tracking-[0.2em] text-slate-400">
        <a href="#services" data-testid="footer-services" onClick={(e) => { e.preventDefault(); scrollToSection("#services"); }} className="hover:text-orange-500 transition-colors">Services</a>
        <a href="#gallery" data-testid="footer-gallery" onClick={(e) => { e.preventDefault(); scrollToSection("#gallery"); }} className="hover:text-orange-500 transition-colors">Past Work</a>
        <a href="#contact" data-testid="footer-contact" onClick={(e) => { e.preventDefault(); scrollToSection("#contact"); }} className="hover:text-orange-500 transition-colors">Contact</a>
        <a href="/admin" data-testid="footer-admin" className="hover:text-orange-500 transition-colors">Admin</a>
      </div>
      <div className="font-mono text-xs uppercase tracking-[0.2em] text-slate-400 flex flex-col gap-2">
        <a href={SITE.phoneHref} data-testid="footer-phone" className="hover:text-orange-500 transition-colors">{SITE.phone}</a>
        <a href={SITE.emailHref} data-testid="footer-email" className="hover:text-orange-500 transition-colors">{SITE.email}</a>
        <span className="text-slate-600">{SITE.hours}</span>
      </div>
    </div>
    <div className="max-w-[1400px] mx-auto mt-10 pt-6 border-t border-white/5 flex flex-col sm:flex-row justify-between gap-2">
      <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-slate-600">
        © {new Date().getFullYear()} Brickn-Ridge Construction. All rights reserved.
      </p>
      <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-slate-600">Lawrenceville, Illinois</p>
    </div>
  </footer>
);
